
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { validateHTMLColorHex } from 'validate-color';
import TextField from '@/components/shared/TextField.vue';
import SelectComponent from '@/components/shared/Select.vue';

@Component<TagFormFields>({
	components: {
		TextField,
		SelectComponent,
		ValidationProvider
	}
})
export default class TagFormFields extends Vue {
	@Prop({ type: Object, required: true }) private tag!: TagForm;
	@Prop({ type: String, required: false, default: 'tag' }) private idPrefix!: string;

	/*
	 * The parent swaps the whole form object when it loads a different tag or resets the editor, so the
	 * swatch resyncs on identity change only. In-place colour edits are handled by the two methods
	 * below and must not be clobbered here.
	 */
	@Watch('tag')
	private onTagChange(): void {
		this.displayColor = this.tag.colorHex;
	}

	private readonly iconOptions: string[] = [
		'mdi-food',
		'mdi-star',
		'mdi-heart',
		'mdi-food-apple',
		'mdi-leaf',
		'mdi-alpha-v-circle-outline',
		'mdi-fire',
		'mdi-snowflake',
		'mdi-cow-off',
		'mdi-barley-off',
		'mdi-peanut-off',
		'mdi-chili-off',
		'mdi-chili-mild',
		'mdi-chili-medium',
		'mdi-chili-hot',
		'mdi-leaf-maple',
		'mdi-food-kosher',
		'mdi-food-halal'
	];
	private colorPickerOpened: boolean = false;
	private displayColor: string = this.tag.colorHex;

	/**
	 * Force a leading '#' so a pasted hex without one still validates.
	 *
	 * @param {string} value
	 * @return {string}
	 */
	private forceHashPrefix(value: string): string {
		if (value) {
			return value.startsWith('#') ? value : `#${value}`;
		}
		return '';
	}

	/**
	 * @param {string} value
	 * @return {void}
	 */
	private updateColorFromInput(value: string): void {
		const colorValue: string = this.forceHashPrefix(value);
		this.tag.colorHex = colorValue;
		this.displayColor = validateHTMLColorHex(colorValue) ? colorValue : '#ccc';
	}

	/**
	 * @param {ColorPickerEvent} event
	 * @return {void}
	 */
	private updateColorFromPicker(event: ColorPickerEvent): void {
		this.displayColor = event.hex;
		this.tag.colorHex = event.hex;
	}
}
